export default __webpack_public_path__ + "static/media/interim_help_icon.4707dac0.svg";